import React, { useState, useEffect } from 'react';
import { isIdeaSaved, saveIdea, unsaveIdea } from '../utils/searchService';
import SavedIcon from '../assets/saved.png';   // Unsaved state
import SavedFilledIcon from '../assets/saved-2.png'; // Saved state

const SaveButton = ({ userId, ideaId, className = "", onToggle }) => {
    const [saved, setSaved] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;

        const checkStatus = async () => {
            if (!userId || !ideaId) return;
            const isSaved = await isIdeaSaved(userId, ideaId);
            if (isMounted) setSaved(isSaved);
        };

        checkStatus();
        return () => { isMounted = false; };
    }, [userId, ideaId]);

    const toggleSave = async (e) => {
        e.stopPropagation(); // Prevent card click
        if (!userId) {
            alert("Please login to save ideas.");
            return;
        }

        if (loading) return;
        setLoading(true);

        // Optimistic update
        const previousState = saved;
        setSaved(!saved);

        try {
            if (previousState) {
                // Was saved, now unsaving
                await unsaveIdea(userId, ideaId);
            } else {
                // Was not saved, now saving
                await saveIdea(userId, ideaId);
            }

            // Notify parent if callback exists
            if (onToggle) {
                onToggle(!previousState);
            }

        } catch (error) {
            console.error("Failed to toggle save:", error);
            // Revert on error
            setSaved(previousState);
            alert("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <button
            className={`save-button ${className}`}
            onClick={toggleSave}
            title={saved ? "Unsave Idea" : "Save Idea"}
            style={{
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                padding: '4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 10
            }}
        >
            <img
                src={saved ? SavedFilledIcon : SavedIcon}
                alt={saved ? "Saved" : "Save"}
                style={{
                    width: '24px',
                    height: '24px',
                    objectFit: 'contain',
                    filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.5))' // Make it pop on images
                }}
            />
        </button>
    );
};

export default SaveButton;
